// @flow

import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { colors, fontWeight } from '../../constants';
import { TrixEditor } from 'react-trix';

import 'trix/dist/trix';
import 'trix/dist/trix.css';

type Props = {
  hideAttachments: boolean,
};

const RichText = (props: Props) => {
  const { hideAttachments, ...otherProps } = props;
  return (
    <>
      <GlobalStyle />
      <TrixContainer hideAttachments={hideAttachments}>
        <TrixEditor {...otherProps} />
      </TrixContainer>
    </>
  );
};

RichText.defaultProps = {
  hideAttachments: false,
};

const TrixContainer = styled.div`
  ${(props) =>
    props.hideAttachments &&
    `
		.trix-button-group.trix-button-group--file-tools {
			display: none;
		}
	`}
`;

const GlobalStyle = createGlobalStyle`
	html trix-toolbar {
		.trix-button-row {
			padding: 5px;
			background: ${colors.lighterGrey};
			border: 1px solid ${colors.lightGrey};
			border-bottom: none;
			border-top-left-radius: 4px;
			border-top-right-radius: 4px;
		}

		.trix-button-group {
			margin: 0;
			border: none;

			&:not(:first-child) {
				margin-left: 2.5vw;
			}
		}

		.trix-button {
			border-bottom: none;
			border-radius: 4px;

			&.trix-active {
				background: ${colors.lightGrey};
			}

			&:not(:first-child) {
				border-left: none;
				margin-left: 1px;
			}
		}

		.trix-button--icon {
			height: 2.2em;
			width: 2.4em;

			&:before {
				background-size: 22px;
			}
		}

		.trix-dialog {
			box-shadow: none;
			border: 1px solid ${colors.lightGrey};
			border-top: 2px solid ${colors.lightGrey};
			border-radius: 0;
			background: ${colors.lightestGrey};
			font-size: 0.9em;
		}

		.trix-dialog--link {
			max-width: 100%;
		}

		.trix-button--dialog {
			padding: 0.7em;

			&:hover {
				background: ${colors.lightGrey};
			}
		}
	}

	html trix-editor {
		border: 1px solid ${colors.lightGrey};
		border-top-left-radius: 0;
		border-top-right-radius: 0;

    font-size: 14px;
    ${fontWeight('normal')};

    resize: vertical;
    overflow-y: auto;

		h1 {
			font-size: 1.5em;
		}

    ul, ol {
      list-style-position: inside;
      padding-inline-start: 15px;
    }

    ul {
      list-style-type: disc;
    }
    ul ul {
      list-style-type: circle;
    }
    ul ul ul {
      list-style-type: square;
    }

    ol {
      list-style-type: decimal;
    }

    pre {
      font-family: monospace;
      white-space: pre;
      padding: 8px;
      background-color: #fafafa;
      border: 1px solid #e1e1e1;
      border-radius: 3px;
      color: ${colors.darkerGrey};
      line-height: 22px;
      white-space: pre-wrap;
    }

    blockquote {
      margin-top: 10px;
      margin-bottom: 10px;
      margin-left: 25px;
      padding-left: 15px;
      border-left: 3px solid ${colors.mediumGrey};
    }
  }

  [data-trix-attachment] {
    display: inline-block;
  }
`;

export default RichText;
